import React from 'react';
import { Marker } from '@react-google-maps/api';
import { useMapContext } from '@hero/web-context';

/**
 * CurrentLocationMarker - Renders blue dot marker for user's current location
 * Uses context to access current location and map utilities
 */
export function CurrentLocationMarker() {
  const ctx = useMapContext();

  if (
    !ctx.showUserCurrentLocation ||
    !ctx.currentLocation ||
    !ctx.currentLocation.cords ||
    !ctx.isLoaded ||
    typeof google === 'undefined' ||
    !google.maps
  ) {
    return null;
  }

  return (
    <Marker
      key={`current-location-${ctx.currentLocation.cords.lat}-${ctx.currentLocation.cords.lng}`}
      position={ctx.currentLocation.cords}
      clickable={true}
      onClick={() => {
        if (ctx.map && ctx.currentLocation?.cords) {
          ctx.smoothZoomToLocation(ctx.map, ctx.currentLocation.cords, 15);
        }
      }}
      zIndex={google.maps.Marker.MAX_ZINDEX + 1}
      icon={{
        url:
          'data:image/svg+xml;charset=UTF-8,' +
          encodeURIComponent(`
            <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
              <circle cx="14" cy="14" r="14" fill="#4285F4" opacity="0.15">
                <animate attributeName="r" values="14;18;14" dur="2s" repeatCount="indefinite"/>
                <animate attributeName="opacity" values="0.15;0;0.15" dur="2s" repeatCount="indefinite"/>
              </circle>
              <circle cx="14" cy="14" r="11" fill="#ffffff" opacity="0.9" stroke="#4285F4" stroke-width="1.5"/>
              <circle cx="14" cy="14" r="7" fill="#4285F4"/>
            </svg>
          `),
        scaledSize: new google.maps.Size(28, 28),
        anchor: new google.maps.Point(14, 14),
      }}
      title={ctx.currentLocation.fullAddress || 'Current Location'}
    />
  );
}
